export default __webpack_public_path__ + "82d1efecf335ab1b0136bde36cd4b578.png";